import { atom, useAtom } from "jotai";
import { DocumentsTypes, PrintTemplate } from "types";
import { getPrintTemplates } from "features/PrintTemplates/api";

export type PrintTemplatesState = {
  activeDocumentType: DocumentsTypes | null;
  activePrintTemplate: PrintTemplate | null;
};

type UsePrintTemplatesStateReturn = {
  printTemplatesState: PrintTemplatesState;
  setPrintTemplatesState: React.Dispatch<
    React.SetStateAction<PrintTemplatesState>
  >;
};

export const documentsTypesAtom = atom<PrintTemplatesState>({
  activeDocumentType: null,
  activePrintTemplate: null,
});

export const printTemplatesAtom = atom<PrintTemplate[]>([]);

export const getAndSetPrintTemplatesAtom = atom(
  null,
  async (get, set, docOperation?: string | null) => {
    if (!docOperation) {
      docOperation =
        get(documentsTypesAtom).activeDocumentType?.operationid || null;
    }
    const { data } = await getPrintTemplates({ doc_operation: docOperation });
    if (data) {
      set(printTemplatesAtom, data);
    }
  }
);

export const usePrintTemplatesState = (): UsePrintTemplatesStateReturn => {
  const [printTemplatesState, setPrintTemplatesState] =
    useAtom(documentsTypesAtom);

  return { printTemplatesState, setPrintTemplatesState };
};
